import { useContext, createContext } from 'react';

/*
 *  Ported code from react-aria-components as of V.1.2.1 use the original commit in the repo
 *  to diff any added code since the original commit.
 */

var PortalContext = /*#__PURE__*/createContext({});
function useUNSTABLE_PortalContext() {
  var _useContext;
  return (_useContext = useContext(PortalContext)) !== null && _useContext !== void 0 ? _useContext : {};
}

export { PortalContext, useUNSTABLE_PortalContext };
//# sourceMappingURL=portal-provider.esm.js.map
